import './index.css';
import Clarity from '@microsoft/clarity';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import App from './App';
import { buildInfo } from './config/buildInfo';
import { getMsClarityEnv, getMsClarityId, loadRuntimeConfig } from './config/runtimeConfig';
import { buildScopes, createOktaClient } from './contexts/auth/oktaClient';
import { buildAuthConfigFromRuntime } from './contexts/AuthContext';
import OktaSecurity from './OktaSecurity';

// Load env.json first, then render application
loadRuntimeConfig().finally(() => {
  const rootElement = document.getElementById('root');
  if (!rootElement) return;

  const msClarityId = getMsClarityId();
  const msClarityEnv = getMsClarityEnv();
  if (msClarityId) {
    Clarity.init(msClarityId);
    Clarity.setTag('uiVersion', buildInfo.version);
    if (msClarityEnv) {
      Clarity.setTag('env', msClarityEnv);
    }
  }

  const runtimeAuthConfig = buildAuthConfigFromRuntime() || {
    issuer: '',
    clientId: '',
    redirectUri: '',
    scopes: [],
  };

  const scopes = buildScopes(runtimeAuthConfig);

  const oktaAuth = createOktaClient(runtimeAuthConfig, scopes);

  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <OktaSecurity oktaAuth={oktaAuth}>
          <App />
        </OktaSecurity>
      ),
      children: [{ path: '*' }],
    },
  ]);

  createRoot(rootElement).render(
    <StrictMode>
      <RouterProvider router={router} />
    </StrictMode>,
  );
});
